import { makeStyles, createStyles } from '@material-ui/core/styles';

const brandStyles = {
  forreston: {
    logo: {
      top: '18%',
      right: 0,
      height: '68vh'
    }
  },
  cfm: {
    logo: {
      left: 0,
      height: '100vh'
    }
  }
};

const styles = (theme) =>
  createStyles({
    // Flex-grows to fill the space left in the #root column below the header,
    // rather than a fixed calc(100vh - headerHeight). This keeps the scroll
    // container's bottom on-screen when a body-level banner (Appcues) is shown. (#30714)
    layout: {
      position: 'relative',
      width: '100%',
      left: 0,
      transition: '225ms cubic-bezier(0, 0, 0.2, 1) 0ms',
      flex: '1 1 auto',
      minHeight: 0,
      'overflow-y': 'auto'
    },
    loading: {
      display: 'flex',
      paddingTop: 0,
      alignItems: 'center',
      justifyContent: 'center'
    },
    container: ({ showHeader }) => ({
      width: 1200,
      height: showHeader ? 'auto' : '100vh',
      marginLeft: 'auto',
      marginRight: 'auto',
      paddingTop: showHeader ? theme.spacing(10) : 0
    }),
    logo: ({ brand }) => ({
      position: 'absolute',
      top: 0,
      right: 0,
      height: '100vh',
      ...(brandStyles[brand]?.logo || {})
    })
  });

export default makeStyles(styles);
